// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"472":"settings","597":"projects","809":"users","884":"admin"}[chunkId] + "." + {"472":"2eb8abfb","597":"480b79e8","809":"525d8cde","884":"15efb3d5"}[chunkId] + ".css";
};